import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import CompanyPage
  from '@fuww/library/src/Layouts/CompanyPage';
import { NextPageWithLayout } from 'next';
import TextWithImage from '../components/TextWithImage';
import Layout from '../components/Layout';
import messages from '../lib/messages.mjs';
import Head from '../components/Head';
import Hero from '../components/Hero';
import { textWithImageConfigurations }
  from '../lib/imageConfigurations';
import getSourceSet from '../lib/getSourceSet';
import { useSiteContext } from '../components/SiteContext';
import getConnectionField, {
  ConnectionField,
} from '../lib/queries/getConnectionField';
import articlesConnectionQuery
  from '../lib/queries/news/articlesConnectionQuery.graphql';
import withQuery from '../lib/withQuery';
import Articles from '../components/News/ArticleFeed';
import createCompanyBreadcrumbs from '../lib/createCompanyBreadcrumbs';
import { CompanyPageWithDataProperties } from './employer-branding';
import getPartnerVariables from '../lib/getPartnerVariables';
import {
  ArticlesConnectionQuery,
  ArticlesConnectionQueryVariables,
} from '../lib/graphql/api/graphql';

const headerImageUrls = {
  mobile: [
    'https://r.fashionunited.com/ME8p68kPjAQpjTy7T1Iajd9Hf49N4sB4SbDy4y00vVY/resize:fill:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvY29udGVudC1tYXJrZXRpbmctcGFnZXMtaGVhZGVyLXcwY2JkcGFsLTIwMjMtMTEtMjAucG5n',
    'https://r.fashionunited.com/rSs8ltThXYn_iy47RqNA446PBrT58DiKy5MMAkC6B6I/resize:fill:360:288:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvY29udGVudC1tYXJrZXRpbmctcGFnZXMtaGVhZGVyLXcwY2JkcGFsLTIwMjMtMTEtMjAucG5n',
    'https://r.fashionunited.com/N9Wd5ATVy91p8Iwdw8XtA5zxzH5svrqR5m9KlufClMo/resize:fill:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvY29udGVudC1tYXJrZXRpbmctcGFnZXMtaGVhZGVyLXcwY2JkcGFsLTIwMjMtMTEtMjAucG5n',
  ],
  desktop: [
    'https://r.fashionunited.com/sgjMwRKCZd_n0zgqKjqvRNUH5H6Pptgcv3SFuc6q13k/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvY29udGVudC1tYXJrZXRpbmctcGFnZXMtaGVhZGVyLXcwY2JkcGFsLTIwMjMtMTEtMjAucG5n',
    'https://r.fashionunited.com/q3xNPRNLrbvYSWRum3apNdHU5DREUIAlCBS5ioOXxic/resize:fill:1350:277:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvY29udGVudC1tYXJrZXRpbmctcGFnZXMtaGVhZGVyLXcwY2JkcGFsLTIwMjMtMTEtMjAucG5n',
    'https://r.fashionunited.com/pFJStMRsMGlZ70zTOAqA1HHZ60dRoa6PnxG7ufFJuF0/resize:fill:2560:526:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvY29udGVudC1tYXJrZXRpbmctcGFnZXMtaGVhZGVyLXcwY2JkcGFsLTIwMjMtMTEtMjAucG5n',
    'https://r.fashionunited.com/Ef7c4d1uNPQhaUP-m5xxTbCH9Wg3zb08wwj4Yzo88WU/resize:fill:5120:1052:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvY29udGVudC1tYXJrZXRpbmctcGFnZXMtaGVhZGVyLXcwY2JkcGFsLTIwMjMtMTEtMjAucG5n',
  ],
};

const imageUrls = {
  advertorial: [
    'https://r.fashionunited.com/zw_vTk9WkQ1-rDGwbQijT6CfNI4pxxzgIbpeNx766fY/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvYWR2ZXJ0b3JpYWwtaW5jbHVkaW5nLW5ld3NsZXR0ZXIucG5n',
    'https://r.fashionunited.com/rNEJ9P4SUOtyrEe6qIPcFZgPfgNjI6Z4gTFHpH7n95s/resize:fill:360:240:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvYWR2ZXJ0b3JpYWwtaW5jbHVkaW5nLW5ld3NsZXR0ZXIucG5n',
    'https://r.fashionunited.com/m10ne8KS-89Lm2ouD5oG5-YOzH25jOjDEngO70oy4wM/resize:fill:460:307:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvYWR2ZXJ0b3JpYWwtaW5jbHVkaW5nLW5ld3NsZXR0ZXIucG5n',
    'https://r.fashionunited.com/k7x2Ugvoqbn9hG_p-BxJAC9XU-M3dn1uTCsWSq0l8So/resize:fill:920:614:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvYWR2ZXJ0b3JpYWwtaW5jbHVkaW5nLW5ld3NsZXR0ZXIucG5n',
  ],
  interview: [
    'https://r.fashionunited.com/cI3ZYkrys8vCYzOPnYbceoDoYE-MZHhmngrYMbcDpTI/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvaW50ZXJ2aWV3LnBuZw',
    'https://r.fashionunited.com/FO8ao2L3ShbqVf0p-cZUdbDUwnE7HuY0b-cKQwKSpD8/resize:fill:360:240:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvaW50ZXJ2aWV3LnBuZw',
    'https://r.fashionunited.com/1k0v3U24b2l1REU5Ml-eDmrqd7NX0gKSbJ-U7QeamIE/resize:fill:460:307:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvaW50ZXJ2aWV3LnBuZw',
    'https://r.fashionunited.com/Sflox_2Q1a6-gjq8eWPO--NPgHzQf0Zym0-63dsQAbY/resize:fill:920:614:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvaW50ZXJ2aWV3LnBuZw',
  ],
  translation: [
    'https://r.fashionunited.com/kYeNqWVxjVwmJQGUYRXyNYG5mdPcbUVJq_HoRihQGkk/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdHJhbnNsYXRpb24ucG5n',
    'https://r.fashionunited.com/bMjRpQlvKODojEPK23ZpmIGxeA3zIrGYjrFmh3FMIpk/resize:fill:360:240:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdHJhbnNsYXRpb24ucG5n',
    'https://r.fashionunited.com/9vPoCpo1G0XQAENC_BScGiJpzVFNWSB9fOibENT9Yjw/resize:fill:460:307:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdHJhbnNsYXRpb24ucG5n',
    'https://r.fashionunited.com/q38pTgxWuXBKqc-rtOCoIYN_1gKn0ZF-Y6_0YN7oWb8/resize:fill:920:614:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdHJhbnNsYXRpb24ucG5n',
  ],
  socialMediaCampaign: [
    'https://r.fashionunited.com/tzDnEcqISQ4TPrG0FkPt1cN1gLhYGX_mCdmTCblpWWg/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvc29jaWFsLW1lZGlhLWNhbXBhaWducy5wbmc',
    'https://r.fashionunited.com/vI6rttviJNp7cx8D6OJFHFO4d1JQmg1JURf0YY35WVs/resize:fill:360:240:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvc29jaWFsLW1lZGlhLWNhbXBhaWducy5wbmc',
    'https://r.fashionunited.com/SUzksZwP_-Y0O-CXHQlALnBv9it8CC7U8i2RwzWcUdc/resize:fill:460:307:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvc29jaWFsLW1lZGlhLWNhbXBhaWducy5wbmc',
    'https://r.fashionunited.com/VQ3wIXVIfk9T_X3I2vWxXdIadxplyG95nEhpbp3pghE/resize:fill:920:614:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvc29jaWFsLW1lZGlhLWNhbXBhaWducy5wbmc',
  ],
  companyPage: [
    'https://r.fashionunited.com/8jeb0jf0nDcsU6fcGDtcU02foB6CryWxlg7WNjZeLr4/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvY29tcGFueS1wYWdlLWV4YW1wbGUucG5n',
    'https://r.fashionunited.com/or4mPBdXyRMEaMrm4f6o1Kt633HnztSCCVZikB4OFfk/resize:fill:360:240:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvY29tcGFueS1wYWdlLWV4YW1wbGUucG5n',
    'https://r.fashionunited.com/SIJtg_HQLKuyuCyUvrRNLh5injVLhGNwz7uTylb5RIU/resize:fill:460:307:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvY29tcGFueS1wYWdlLWV4YW1wbGUucG5n',
    'https://r.fashionunited.com/mdEQwKGabnWu-kqaruD1IfXdvLX3kXL_3PAjdK7YWEc/resize:fill:920:614:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvY29tcGFueS1wYWdlLWV4YW1wbGUucG5n',
  ],
};

const ContentMarketing = ({
  data,
  fetchMore,
  field,
  loading,
  variables,
}: CompanyPageWithDataProperties) => {
  const intl = useIntl();

  const breadcrumbs = createCompanyBreadcrumbs({
    intl,
    crumbRoute: 'content-marketing',
    crumbLabel: intl.formatMessage(messages['contentMarketing.header']),
  });

  return (
    <>
      <Head
        title={intl.formatMessage(messages['contentMarketing.header'])}
        description={intl.formatMessage(
          messages['contentMarketing.description'],
        )}
      />
      <CompanyPage
        advertorials={(
          <Articles
            articles={data[field]}
            data={data}
            field={field}
            fetchMore={fetchMore}
            loading={loading}
            preloadFirst
            variables={variables}
          />
        )}
        partnerContentTitle={intl.formatMessage(
          messages['contentMarketing.partnerContentTitle'],
        )}
        breadcrumbs={breadcrumbs}
        description={intl.formatMessage(
          messages['contentMarketing.description'],
        )}
        title={intl.formatMessage(messages['contentMarketing.header'])}
        textWithImageComponents={(
          <>
            <TextWithImage
              buttonLabel={intl.formatMessage(
                messages['contentMarketing.buttonLabel'],
              )}
              buttonHref="mailto:media@fashionunited.com"
              buttonVariant="contained"
              description={intl.formatMessage(
                messages['contentMarketing.advertorialBody'],
              )}
              imagePosition="right"
              imageUrls={imageUrls.advertorial}
              srcSet={getSourceSet(
                textWithImageConfigurations, imageUrls.advertorial,
              )}
              title={intl.formatMessage(
                // eslint-disable-next-line max-len
                messages['contentMarketing.advertorialIncludingNewsletterTitle'],
              )}
            />
            <TextWithImage
              buttonLabel={intl.formatMessage(
                messages['contentMarketing.buttonLabel'],
              )}
              buttonHref="mailto:media@fashionunited.com"
              buttonVariant="contained"
              description={intl.formatMessage(
                messages['contentMarketing.interviewBody'],
              )}
              imagePosition="left"
              imageUrls={imageUrls.interview}
              srcSet={getSourceSet(
                textWithImageConfigurations, imageUrls.interview,
              )}
              title={intl.formatMessage(
                messages['contentMarketing.interviewTitle'],
              )}
            />
            <TextWithImage
              buttonLabel={intl.formatMessage(
                messages['contentMarketing.buttonLabel'],
              )}
              buttonHref="mailto:media@fashionunited.com"
              buttonVariant="contained"
              description={intl.formatMessage(
                messages['contentMarketing.translationBody'],
              )}
              imagePosition="right"
              imageUrls={imageUrls.translation}
              srcSet={getSourceSet(
                textWithImageConfigurations, imageUrls.translation,
              )}
              title={intl.formatMessage(
                messages['contentMarketing.translationTitle'],
              )}
            />
            <TextWithImage
              buttonLabel={intl.formatMessage(
                messages['contentMarketing.buttonLabel'],
              )}
              buttonHref="mailto:media@fashionunited.com"
              buttonVariant="contained"
              description={intl.formatMessage(
                messages['contentMarketing.socialMediaCampaignBody'],
              )}
              imagePosition="left"
              imageUrls={imageUrls.socialMediaCampaign}
              srcSet={getSourceSet(
                textWithImageConfigurations, imageUrls.socialMediaCampaign,
              )}
              title={intl.formatMessage(
                messages['contentMarketing.socialMediaCampaignTitle'],
              )}
            />
            <TextWithImage
              buttonLabel={intl.formatMessage(
                messages['contentMarketing.buttonLabel'],
              )}
              buttonHref="mailto:media@fashionunited.com"
              buttonVariant="contained"
              description={intl.formatMessage(
                messages['contentMarketing.companyPageBody'],
              )}
              imagePosition="right"
              imageUrls={imageUrls.companyPage}
              srcSet={getSourceSet(
                textWithImageConfigurations, imageUrls.companyPage,
              )}
              title={intl.formatMessage(
                messages['contentMarketing.companyPageTitle'],
              )}
            />
          </>
        )}
      />
    </>
  );
};

const ContentMarketingWithQuery = withQuery<
ArticlesConnectionQuery,
ArticlesConnectionQueryVariables,
false,
{ field: ConnectionField }
>(ContentMarketing);

const ContentMarketingPage: NextPageWithLayout = () => {
  const { prefix, hasLocalNews, newsboard } = useSiteContext();

  return (
    <ContentMarketingWithQuery
      errorMessage="Error while loading news articles"
      field={getConnectionField(prefix, hasLocalNews)}
      query={articlesConnectionQuery}
      variables={getPartnerVariables(prefix, hasLocalNews, newsboard)}
    />
  );
};

ContentMarketingPage.getLayout = (page: ReactElement) => (
  <Layout
    header={(
      <Hero
        alt="Content marketing banner image"
        imageUrls={headerImageUrls}
      />
  )}
  >
    {page}
  </Layout>
);

export default ContentMarketingPage;
